export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-tools-a894b30762d267f366529bec801b0657.png";